import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StepperType } from "./stepperSlice";

export interface ApplicationState {
    loadedSteppers: StepperType[];
    allPossibleSteppers: StepperType[];
    isAppready?: boolean;
}

const stepperInitialState: ApplicationState = {
    loadedSteppers: [],
    allPossibleSteppers: [StepperType.PensionQuestionnaire, StepperType.ChangePensionContribution],
    isAppready: false,
};

export const applicationSlice = createSlice({
    name: "stepperSlice",
    initialState: stepperInitialState,
    reducers: {
        addLoadedStepper: (
            state,
            action: PayloadAction<{
                stepper: StepperType;
            }>,
        ) => {
            if (!state.loadedSteppers.includes(action.payload.stepper)) {
                state.loadedSteppers = [...state.loadedSteppers, action.payload.stepper];
            }
        },
        setAppReady: (state, action: PayloadAction<boolean>) => {
            state.isAppready = action.payload;
        },
    },
});

export const { addLoadedStepper, setAppReady } = applicationSlice.actions;

export default applicationSlice.reducer;
